import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Text } from '@mantine/core';
import type { StrengthBarV2Props } from './StrengthBar.types';

export const StrengthBar = ({ strengthScore }: StrengthBarV2Props) => {
	const tCommonUi = useTranslationCommonUi();

	const passwordStrengthAttributes = (() => {
		const defaultColor = defaultTheme.v3.colors.gray[4];
		const red = defaultTheme.v3.colors.red[4];
		const orange = defaultTheme.v3.colors.orange[4];
		const green = defaultTheme.v3.colors.teal[8];
		switch (strengthScore) {
			case 1:
				return {
					color: [red, defaultColor, defaultColor, defaultColor],
					word: tCommonUi('password.weak'),
				};
			case 2:
				return {
					color: [red, orange, defaultColor, defaultColor],
					word: tCommonUi('password.okay'),
				};
			case 3:
				return {
					color: [red, orange, green, defaultColor],
					word: tCommonUi('password.good'),
				};
			case 4:
				return {
					color: [green, green, green, green],
					word: tCommonUi('password.strong'),
				};
			default:
				return {
					color: Array.from({ length: 4 }, () => defaultColor),
					word: '',
				};
		}
	})();

	return (
		<div>
			<Text size="B6Bold" c="dark.8" pb={5}>
				{tCommonUi('password.strength')}
			</Text>
			<div className="flex gap-2 w-full h-2">
				{passwordStrengthAttributes.color.map((color, index) => (
					<div
						className="rounded-2xl w-full h-1"
						style={{ backgroundColor: color }}
						key={index}
					/>
				))}
			</div>
			<Text size="B6Medium" c="gray.9">
				{passwordStrengthAttributes.word}
			</Text>
		</div>
	);
};
